import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { PackagesVersionsComponent } from './packages-versions.component';

@NgModule({
    imports: [SharedModule],
    declarations: [PackagesVersionsComponent],
    entryComponents: [PackagesVersionsComponent],
    exports: [PackagesVersionsComponent]
})
export class PackagesVersionsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/packages/packages-versions/packages-versions.module.ts